import React, { Component, useEffect } from 'react'
import Collapsible from '../Collapsible'
import FilterContentType from './FilterContentType'
import FilterGeographies from './FilterGeographies'

export class FilterTimeline extends Component {
  constructor (props) {
    super(props)
    this.collapsible = React.createRef()
  }

  componentDidMount () {
    document.addEventListener('expandFilterTimeLine', () => {
      if (this.collapsible.current != null) {
        this.collapsible.current.openPanel()
      }
    })    
  }

  render () {
    return (
      <div className='article-filtertimeline box-container'>
        <Collapsible ref={this.collapsible} title='Filter Timeline' titleClassName='box-header' id='collapsibleFilterTimeline'>
          <FilterGeographies
            relatedContents={this.props.relatedContents}
            selectedGeographyIds={this.props.selectedGeographyIds}
            onGeographyChanged={this.props.onGeographyChanged}
          />
          <FilterContentType
            relatedContents={this.props.relatedContents}
            selectedContentTypeIds={this.props.selectedContentTypeIds}
            onContentTypeChanged={this.props.onContentTypeChanged}
          />
        </Collapsible>
      </div>
    )
  }
}

export default FilterTimeline
